/* Aurelle theme runtime (cart core adapted from the Amora theme). No dependencies. */
(function () {
  "use strict";

  var A = window.Aurelle || {};
  var $ = function (sel, ctx) {
    return (ctx || document).querySelector(sel);
  };
  var $$ = function (sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  };

  /* ---------------- money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    cents = Number(cents) || 0;
    format = format || A.moneyFormat || "${{amount}}";
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? "," : thousands;
      decimal = decimal === undefined ? "." : decimal;
      var parts = (n / 100).toFixed(precision).split(".");
      var whole = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands,
      );
      return whole + (parts[1] ? decimal + parts[1] : "");
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount":
          return withDelims(cents, 2);
        case "amount_no_decimals":
          return withDelims(cents, 0);
        case "amount_with_comma_separator":
          return withDelims(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator":
          return withDelims(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator":
          return withDelims(cents, 2, "'", ".");
        case "amount_with_space_separator":
          return withDelims(cents, 2, " ", ",");
        case "amount_no_decimals_with_space_separator":
          return withDelims(cents, 0, " ");
        default:
          return withDelims(cents, 2);
      }
    });
  }
  A.formatMoney = formatMoney;

  /* ---------------- toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var t = $("#AurelleToast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove("show");
    }, 2600);
  }
  A.toast = toast;

  /* ---------------- overlays (cart drawer, mobile menu) ---------------- */
  var lastFocus = null;
  function openOverlay(el, opener) {
    if (!el) return;
    lastFocus = opener || document.activeElement;
    el.classList.add("open");
    el.setAttribute("aria-hidden", "false");
    document.body.classList.add("lock");
    var panel = $(".panel", el);
    if (panel)
      setTimeout(function () {
        panel.focus ? panel.focus() : null;
      }, 30);
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) {
      b.setAttribute("aria-expanded", "true");
    });
  }
  function closeOverlay(el) {
    if (!el || !el.classList.contains("open")) return;
    el.classList.remove("open");
    el.setAttribute("aria-hidden", "true");
    if (!$(".drawer.open, .mnav.open")) document.body.classList.remove("lock");
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) {
      b.setAttribute("aria-expanded", "false");
    });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function openCart(opener) {
    openOverlay($("#CartDrawer"), opener);
  }
  A.openCart = openCart;

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape")
      $$(".drawer.open, .mnav.open").forEach(closeOverlay);
  });

  document.addEventListener("click", function (e) {
    var t = e.target;
    var opener = t.closest("[data-cart-open]");
    if (
      opener &&
      $("#CartDrawer") &&
      A.cartType === "drawer" &&
      !document.body.classList.contains("template-cart")
    ) {
      e.preventDefault();
      openCart(opener);
      return;
    }
    if (t.closest("[data-drawer-close]")) {
      closeOverlay($("#CartDrawer"));
      return;
    }
    if (t.closest("[data-menu-open]")) {
      openOverlay($("#MobileNav"), t.closest("[data-menu-open]"));
      return;
    }
    if (t.closest("[data-menu-close]")) {
      closeOverlay($("#MobileNav"));
      return;
    }
    /* anchor links in the mobile menu should close it before scrolling */
    var navLink = t.closest('#MobileNav a[href^="#"]');
    if (navLink) closeOverlay($("#MobileNav"));
  });

  /* ---------------- cart API ---------------- */
  function cartSections() {
    var ids = [];
    if ($("#CartDrawer")) ids.push("cart-drawer");
    var page = $("[data-cart-page]");
    if (page && page.dataset.section) ids.push(page.dataset.section);
    return ids;
  }

  function renderSections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    if (sections["cart-drawer"]) {
      var doc = parser.parseFromString(sections["cart-drawer"], "text/html");
      var fresh = $("#CartDrawer .panel", doc);
      var panel = $("#CartDrawer .panel");
      if (fresh && panel) panel.innerHTML = fresh.innerHTML;
      var inner = $("#CartDrawerInner", doc);
      if (inner) setCount(Number(inner.getAttribute("data-cart-count")) || 0);
    }
    var page = $("[data-cart-page]");
    if (page && sections[page.dataset.section]) {
      var pdoc = parser.parseFromString(
        sections[page.dataset.section],
        "text/html",
      );
      var pfresh = $("#MainCartInner", pdoc);
      var pcur = $("#MainCartInner");
      if (pfresh && pcur) pcur.innerHTML = pfresh.innerHTML;
    }
    dropOrphanProtection();
  }

  /* Shipping Protection left in a cart with no products: Liquid marks its line, we remove it. */
  var droppingProt = false;
  function dropOrphanProtection() {
    var o = $("[data-prot-orphan]");
    if (!o || droppingProt) return;
    droppingProt = true;
    changeLine(Number(o.getAttribute("data-prot-orphan")), 0).then(function () {
      droppingProt = false;
    });
  }

  function setCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      if (el.id === "CartDrawerInner") return;
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(
            data.description ||
              data.message ||
              (A.strings && A.strings.error) ||
              "Error",
          );
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function addItems(items) {
    var sections = cartSections();
    return postJSON(A.routes.cartAdd + ".js", {
      items: items,
      sections: sections.join(","),
      sections_url: window.location.pathname,
    }).then(function (res) {
      renderSections(res.sections);
      document.dispatchEvent(
        new CustomEvent("aurelle:cart-added", { detail: { items: items } }),
      );
      return res;
    });
  }
  A.addItems = addItems;

  function afterAdd(message) {
    if (A.cartType === "page") {
      window.location.href = A.routes.cart;
      return;
    }
    if (A.cartType === "checkout") {
      window.location.href = "/checkout";
      return;
    }
    if ($("#CartDrawer")) openCart();
    else toast(message || (A.strings && A.strings.added));
  }

  var changeQueue = Promise.resolve();
  function changeLine(line, quantity, scope) {
    if (scope) scope.classList.add("is-updating");
    changeQueue = changeQueue.then(function () {
      return postJSON(A.routes.cartChange + ".js", {
        line: line,
        quantity: quantity,
        sections: cartSections().join(","),
        sections_url: window.location.pathname,
      })
        .then(function (res) {
          renderSections(res.sections);
        })
        .catch(function (err) {
          toast(err.message);
          if (scope) scope.classList.remove("is-updating");
        });
    });
    return changeQueue;
  }

  /* line-item controls, delegated so re-rendered markup keeps working */
  document.addEventListener("click", function (e) {
    var step = e.target.closest(".line [data-qty-step]");
    var rm = e.target.closest(".line [data-remove]");
    if (!step && !rm) return;
    e.preventDefault();
    var line = e.target.closest(".line");
    var idx = Number(line.dataset.line);
    if (rm) {
      changeLine(idx, 0, line);
      return;
    }
    var input = $("[data-line-qty]", line);
    var next = Math.max(
      0,
      (Number(input.value) || 0) + Number(step.dataset.qtyStep),
    );
    input.value = next;
    changeLine(idx, next, line);
  });
  /* cart drawer extras: "add N more" bump, "goes with this" add */
  document.addEventListener("click", function (e) {
    var bump = e.target.closest("[data-cart-bump]");
    if (bump) {
      e.preventDefault();
      bump.classList.add("is-updating");
      changeLine(Number(bump.dataset.line), Number(bump.dataset.qty), bump);
      return;
    }
    var addV = e.target.closest("[data-cart-add-variant]");
    if (addV) {
      e.preventDefault();
      addV.classList.add("is-updating");
      addItems([
        { id: Number(addV.dataset.cartAddVariant), quantity: 1 },
      ]).catch(function (err) {
        toast(err.message);
        addV.classList.remove("is-updating");
      });
    }
  });

  /* Shipping Protection switch: on = add the hidden product, off = remove its line */
  document.addEventListener("click", function (e) {
    var sw = e.target.closest("[data-prot]");
    if (!sw) return;
    e.preventDefault();
    if (sw.disabled) return;
    var on = sw.getAttribute("aria-checked") === "true";
    sw.setAttribute("aria-checked", on ? "false" : "true");
    var row = sw.closest(".cprot");
    if (row) row.classList.toggle("is-on", !on);
    sw.disabled = true;
    var job = on
      ? changeLine(Number(sw.dataset.line), 0, row)
      : addItems([{ id: Number(sw.dataset.id), quantity: 1 }]).catch(function (err) {
          toast(err.message);
        });
    job.then(function () {
      sw.disabled = false;
    });
  });
  dropOrphanProtection();

  /* gift countdown: one deadline per browser session, restarts when it runs out */
  function tickCartTimer() {
    var els = $$("[data-cart-timer]");
    if (!els.length) return;
    var mins = Number(els[0].dataset.minutes) || 15;
    var end = 0;
    try {
      end = Number(sessionStorage.getItem("aurelle_gift_end")) || 0;
    } catch (_) {}
    var now = Date.now();
    if (!end || end <= now) {
      end = now + mins * 60000;
      try {
        sessionStorage.setItem("aurelle_gift_end", String(end));
      } catch (_) {}
    }
    var left = Math.max(0, Math.round((end - now) / 1000));
    var txt = Math.floor(left / 60) + ":" + String(left % 60).padStart(2, "0");
    els.forEach(function (el) {
      el.textContent = txt;
    });
  }
  tickCartTimer();
  setInterval(tickCartTimer, 1000);

  var lineTimer;
  document.addEventListener("change", function (e) {
    var input = e.target.closest(".line [data-line-qty]");
    if (!input) return;
    var line = input.closest(".line");
    clearTimeout(lineTimer);
    lineTimer = setTimeout(function () {
      changeLine(
        Number(line.dataset.line),
        Math.max(0, Number(input.value) || 0),
        line,
      );
    }, 250);
  });

  /* ---------------- product form (offers = variants) ---------------- */
  function initProduct(root) {
    var form = $("[data-product-form]", root);
    if (!form || form.dataset.bound) return;
    form.dataset.bound = "1";
    var atc = $("[data-atc]", form);
    var priceEl = $("[data-atc-price]", form);
    var errEl = $("[data-form-error]", form);
    var radios = $$('input[type="radio"][name="id"]', form);

    /* no offer marked as default: select the first available one */
    if (
      radios.length &&
      !radios.some(function (r) {
        return r.checked;
      })
    ) {
      var first = radios.find(function (r) {
        return !r.disabled;
      });
      if (first) first.checked = true;
    }
    function sync() {
      var r = radios.find(function (x) {
        return x.checked;
      });
      if (r && priceEl) priceEl.innerHTML = r.dataset.price;
    }
    form.addEventListener("change", function (e) {
      if (e.target.name === "id") sync();
    });
    sync();

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var r = radios.find(function (x) {
        return x.checked;
      });
      var idInput = r || $('[name="id"]', form);
      if (!idInput) return;
      var props = {};
      /* properties may live outside the form (form="..." attribute) */
      $$('[name^="properties["]').forEach(function (el) {
        if (el.form !== form) return;
        if ((el.type === "checkbox" || el.type === "radio") && !el.checked)
          return;
        var key = el.name.slice(11, -1);
        props[key] = el.value;
      });
      if (errEl) errEl.textContent = "";
      atc.classList.add("is-loading");
      addItems([{ id: Number(idInput.value), quantity: 1, properties: props }])
        .then(function () {
          afterAdd(A.strings && A.strings.added);
        })
        .catch(function (err) {
          if (errEl) errEl.textContent = err.message;
          toast(err.message);
        })
        .then(function () {
          atc.classList.remove("is-loading");
        });
    });
    root._selectOffer = function (pos) {
      var r = radios[pos - 1];
      if (r && !r.disabled) {
        r.checked = true;
        sync();
        r.closest(".offer").scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } else {
        /* no theme offers (bundle app in use): bring the buy area into view */
        (form.closest(".buy__form") || form).scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    };
  }

  /* ---------------- gallery ---------------- */
  function initGallery(root) {
    var g = $("[data-gallery]", root);
    if (!g || g.dataset.bound) return;
    g.dataset.bound = "1";
    var slides = $$("[data-slide]", g);
    var thumbs = $$("[data-thumb]", g);
    var cur = 0;
    function go(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        s.classList.toggle("is-on", j === cur);
        var v = $("video", s);
        if (v) j === cur ? v.play().catch(function () {}) : v.pause();
      });
      thumbs.forEach(function (t, j) {
        t.setAttribute("aria-current", j === cur ? "true" : "false");
      });
      if (thumbs[cur])
        thumbs[cur].scrollIntoView({ block: "nearest", inline: "nearest" });
    }
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        go(Number(t.dataset.thumb));
      });
    });
    var prev = $("[data-gal-prev]", g);
    var next = $("[data-gal-next]", g);
    if (prev)
      prev.addEventListener("click", function () {
        go(cur - 1);
      });
    if (next)
      next.addEventListener("click", function () {
        go(cur + 1);
      });
    /* swipe on touch screens */
    var stage = $(".gallery__stage", g);
    var x0 = null;
    stage.addEventListener(
      "touchstart",
      function (e) {
        x0 = e.touches[0].clientX;
      },
      { passive: true },
    );
    stage.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* ---------------- quiz ---------------- */
  function openDialog(d) {
    if (d.showModal) d.showModal();
    else d.setAttribute("open", "");
  }
  function closeDialog(d) {
    if (d.close) d.close();
    else d.removeAttribute("open");
  }
  function esc(s) {
    var div = document.createElement("div");
    div.textContent = s == null ? "" : String(s);
    return div.innerHTML;
  }
  function runQuiz(dialog, root) {
    var data = JSON.parse($("[data-quiz-data]", dialog).textContent);
    var body = $("[data-quiz-body]", dialog);
    var qs = data.questions || [];
    var step = 0;
    var closeBtn =
      '<button type="button" class="quiz__close" data-quiz-close aria-label="Close">✕</button>';
    function render() {
      if (step >= qs.length) {
        body.innerHTML =
          '<div class="quiz__top"><span>✓</span>' +
          closeBtn +
          "</div>" +
          "<h3>" +
          esc(data.resultTitle) +
          '</h3><p class="muted">' +
          esc(data.resultText) +
          "</p>" +
          (data.resultButton
            ? '<button type="button" class="cta" data-quiz-pick>' +
              esc(data.resultButton) +
              "</button>"
            : "");
        var pick = $("[data-quiz-pick]", body);
        if (pick)
          pick.addEventListener("click", function () {
            closeDialog(dialog);
            if (root._selectOffer)
              root._selectOffer(Number(dialog.dataset.resultOffer) || 1);
          });
      } else {
        var q = qs[step];
        var label = (data.step || "Question {{ n }} of {{ total }}")
          .replace("{{ n }}", step + 1)
          .replace("{{ total }}", qs.length);
        body.innerHTML =
          '<div class="quiz__top"><span>' +
          esc(label) +
          "</span>" +
          closeBtn +
          "</div>" +
          '<div class="quiz__prog"><i style="width:' +
          (step / qs.length) * 100 +
          '%"></i></div>' +
          "<h3>" +
          esc(q.q) +
          '</h3><div class="quiz__opts">' +
          (q.a || [])
            .map(function (a) {
              return (
                '<button type="button">' + esc(String(a).trim()) + "</button>"
              );
            })
            .join("") +
          "</div>";
        $$(".quiz__opts button", body).forEach(function (b) {
          b.addEventListener("click", function () {
            step++;
            render();
          });
        });
      }
      $("[data-quiz-close]", body).addEventListener("click", function () {
        closeDialog(dialog);
      });
    }
    render();
    openDialog(dialog);
  }
  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-quiz-open]");
    if (!opener) return;
    var d = document.getElementById(opener.dataset.quizOpen);
    if (d) runQuiz(d, opener.closest("[data-product-root]") || document);
  });

  /* ---------------- customer videos ---------------- */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest(".vthumb[data-video]");
    if (thumb) {
      var root = thumb.closest("[data-product-root]") || document;
      var modal = $("[data-vmodal]", root);
      if (!modal) return;
      var v = $("video", modal);
      v.src = thumb.dataset.video;
      v.muted = false;
      openDialog(modal);
      v.play().catch(function () {
        v.muted = true;
        v.play().catch(function () {});
      });
      return;
    }
    var close = e.target.closest("[data-vmodal-close]");
    var bg =
      e.target.matches && e.target.matches("dialog.vmodal") ? e.target : null;
    var m = close ? close.closest("dialog") : bg;
    if (m) closeDialog(m);
  });
  document.addEventListener(
    "close",
    function (e) {
      if (e.target.matches && e.target.matches("dialog.vmodal")) {
        var v = $("video", e.target);
        if (v) v.pause();
      }
    },
    true,
  );

  /* ---------------- review rail ---------------- */
  function initRails(scope) {
    $$("[data-rail-root]", scope).forEach(function (sec) {
      if (sec.dataset.bound) return;
      sec.dataset.bound = "1";
      var rail = $("[data-rail]", sec);
      function step(dir) {
        var card = rail.firstElementChild;
        var w = card ? card.getBoundingClientRect().width + 16 : 300;
        rail.scrollBy({ left: dir * w, behavior: "smooth" });
      }
      var p = $("[data-rail-prev]", sec);
      var n = $("[data-rail-next]", sec);
      if (p)
        p.addEventListener("click", function () {
          step(-1);
        });
      if (n)
        n.addEventListener("click", function () {
          step(1);
        });
    });
  }

  /* ---------------- reviews "load more" ---------------- */
  function initReviews(scope) {
    $$("[data-reviews]", scope).forEach(function (sec) {
      var btn = $("[data-more]", sec);
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", function () {
        var hidden = $$("[data-more-card][hidden]", sec);
        hidden.slice(0, 6).forEach(function (c) {
          c.hidden = false;
        });
        if (hidden.length <= 6) btn.remove();
      });
    });
  }

  /* ---------------- countdown to local midnight ---------------- */
  function initTimers() {
    var timers = $$("[data-midnight-timer]");
    if (!timers.length) return;
    function pad(n) {
      return String(n).padStart(2, "0");
    }
    /* "YYYY-MM-DD" -> end of that day in the shopper's local time */
    function endOf(str) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(str || "").trim());
      return m ? new Date(+m[1], +m[2] - 1, +m[3], 24, 0, 0, 0) : null;
    }
    function tick() {
      var now = new Date();
      timers.forEach(function (t) {
        var end = endOf(t.dataset.end);
        if (end && end <= now) {
          /* sale is over: back to the default bar and a daily countdown */
          var bar = t.closest(".announce--hw");
          if (bar) {
            bar.classList.remove("announce--hw");
            $$(".hw-deco, .hw-pumpkin, .hw-offer", bar).forEach(function (x) { x.remove(); });
            var txt = $("[data-announce-text]", bar);
            if (txt && bar.dataset.afterText) txt.textContent = bar.dataset.afterText;
          }
          delete t.dataset.end;
          end = null;
        }
        if (!end) {
          end = new Date(now);
          end.setHours(24, 0, 0, 0);
        }
        var d = Math.max(0, Math.floor((end - now) / 1000));
        var days = Math.floor(d / 86400);
        var dEl = $("[data-d]", t);
        if (dEl) {
          dEl.hidden = days === 0;
          dEl.textContent = days + "d";
        }
        d = d % 86400;
        $("[data-h]", t).textContent = pad(Math.floor(d / 3600));
        $("[data-m]", t).textContent = pad(Math.floor((d % 3600) / 60));
        $("[data-s]", t).textContent = pad(d % 60);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------------- misc ---------------- */
  function initSort() {
    $$("[data-sort-select]").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sel.value);
        url.searchParams.delete("page");
        window.location.href = url.toString();
      });
    });
  }
  function initCountrySelects() {
    $$("select[data-default]").forEach(function (sel) {
      if (sel.dataset.default) sel.value = sel.dataset.default;
    });
  }

  function initScope(scope) {
    $$("[data-product-root]", scope).forEach(function (root) {
      try {
        initProduct(root);
        initGallery(root);
      } catch (err) {
        if (window.console) console.error("[Aurelle] product init failed", err);
      }
    });
    initRails(scope);
    initReviews(scope);
  }
  function init() {
    initScope(document);
    initTimers();
    initSort();
    initCountrySelects();
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();

  /* theme editor: re-init a section after it is re-rendered */
  document.addEventListener("shopify:section:load", function (e) {
    initScope(e.target);
  });

  window.Aurelle = A;
})();
